export const CHECKOUT_URL = 'https://profesor-de-ingles.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ihY5ZMT6LTe2RjHcgV86M3/Mega_Pack_de_Ingles_para_Primaria.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR DE INGLÉS INICIAL'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'MATERIAL DISPERSO',
    desc: 'Guardás fichas, juegos, planificaciones y ejercicios de distintos sitios, pero después te cuesta reunir todo en una clase completa.',
  },
  {
    icon: 'help' as const,
    title: 'NO SABÉS QUÉ ENSEÑAR PRIMERO',
    desc: 'Saludos, números, vocabulario, gramática, lectura, escritura... hay tantos contenidos que organizar una secuencia puede resultar complicado.',
  },
  {
    icon: 'clipboard' as const,
    title: 'TE FALTA UNA PLANIFICACIÓN',
    desc: 'Querés enseñar con actividades claras, objetivos definidos y evaluaciones, pero necesitás una estructura que conecte cada contenido.',
  },
  {
    icon: 'clock' as const,
    title: 'PERDÉS HORAS PREPARANDO',
    desc: 'Terminás dedicando demasiado tiempo a buscar recursos y organizar clases en lugar de concentrarte en enseñar.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'calendar' as const,
    title: 'PLANIFICACIÓN Y ORGANIZACIÓN DE CLASES',
    desc: 'Aprendé a organizar clases de inglés para primaria con objetivos, secuencias didácticas, tiempos, recursos, actividades y estrategias adaptadas a niños de 6 a 12 años.',
  },
  {
    icon: 'message' as const,
    title: 'INGLÉS DESDE CERO: PRIMERAS PALABRAS',
    desc: 'Trabajá saludos, presentaciones, números, colores, objetos escolares y primeras expresiones mediante ejercicios y actividades para comenzar desde lo más básico.',
  },
  {
    icon: 'puzzle' as const,
    title: 'GRAMÁTICA INICIAL PASO A PASO',
    desc: 'Enseñá pronombres, verbo to be, artículos, plurales, have got, can y estructuras sencillas con explicaciones, ejemplos y ejercicios prácticos.',
  },
  {
    icon: 'book' as const,
    title: 'VOCABULARIO ESENCIAL PARA PRIMARIA',
    desc: 'Organizá la enseñanza de animales, familia, cuerpo, alimentos, ropa, casa, escuela y rutinas mediante vocabulario temático y actividades de aplicación.',
  },
  {
    icon: 'gamepad' as const,
    title: 'ACTIVIDADES Y JUEGOS DIDÁCTICOS',
    desc: 'Descubrí propuestas para trabajar inglés mediante juegos, dinámicas grupales, ejercicios escritos, actividades orales y recursos para reforzar contenidos.',
  },
  {
    icon: 'check' as const,
    title: 'EVALUACIONES, SEGUIMIENTO Y PROYECTOS',
    desc: 'Aprendé a preparar evaluaciones, registrar avances, identificar dificultades y desarrollar proyectos que integren vocabulario, gramática y comunicación.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'file' as const,
    title: '100 FICHAS DE ACTIVIDADES IMPRIMIBLES',
    desc: 'Una colección de 100 propuestas de actividades para reforzar vocabulario, gramática, lectura y escritura, adaptables a diferentes edades y niveles.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'check' as const,
    title: '50 EVALUACIONES DE INGLÉS CON RESPUESTAS',
    desc: '50 evaluaciones organizadas por contenidos, con ejercicios y respuestas para comprobar aprendizajes y facilitar la corrección.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'calendar' as const,
    title: 'PLANIFICACIONES DOCENTES EDITABLES',
    desc: 'Modelos de planificación para organizar objetivos, contenidos, actividades, recursos y evaluaciones sin tener que empezar cada clase desde cero.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'cards' as const,
    title: '200 FLASHCARDS Y JUEGOS DIDÁCTICOS',
    desc: '200 propuestas de tarjetas de vocabulario y actividades para desarrollar recursos visuales, practicar palabras y realizar juegos de repaso.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'bulb' as const,
    title: '30 CLASES DE INGLÉS LISTAS PARA USAR',
    desc: '30 propuestas de clases organizadas con objetivos, inicio, desarrollo, actividades y evaluación para facilitar la preparación docente.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'clock' as const,
    title: 'MENOS TIEMPO BUSCANDO',
    desc: 'Dejá de recorrer páginas y descargar materiales sueltos. Seguí una estructura que reúne contenidos, actividades y evaluaciones.',
  },
  {
    icon: 'book' as const,
    title: 'MÁS RECURSOS PARA ENSEÑAR',
    desc: 'Contá con propuestas de vocabulario, gramática, juegos, fichas, planificaciones y clases para trabajar diferentes contenidos.',
  },
  {
    icon: 'list' as const,
    title: 'CLASES MÁS ORGANIZADAS',
    desc: 'Empezá a preparar tus clases con objetivos claros, actividades relacionadas y herramientas para comprobar lo aprendido.',
  },
  {
    icon: 'heart' as const,
    title: 'MÁS SEGURIDAD AL PLANIFICAR',
    desc: 'Construí una base de recursos que te permita adaptar tus clases al grupo y dedicar más tiempo a acompañar a tus alumnos.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Doy clases en tres grados distintos y cada domingo se me iba la tarde armando planificaciones. Con el tomo de planificación y las planificaciones editables organicé el trimestre completo en un fin de semana. Ahora sé qué contenido va en cada clase y llego a la escuela tranquila.',
    author: 'Valeria Sosa',
    role: 'Profesora de inglés en primaria, 34 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Soy maestra de grado y este año me pidieron cubrir inglés en 1.º y 2.º. No sabía por dónde arrancar con chicos tan chiquitos. El tomo de primeras palabras y las flashcards me salvaron: arranqué con saludos y colores, y los chicos ya se presentan solos en inglés.',
    author: 'Mariana Gutiérrez',
    role: 'Maestra de grado, 41 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Me recibí hace poco y en mi primer año sentía que improvisaba todo. Las 30 clases listas para usar me dieron una estructura de inicio, desarrollo y cierre que ahora adapto a cada grupo. La directora me felicitó por lo ordenadas que tengo las secuencias.',
    author: 'Florencia Ruiz',
    role: 'Profesora de inglés recién recibida, 26 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Trabajo en dos escuelas y corregir me llevaba horas. Las 50 evaluaciones con respuestas me ahorran muchísimo tiempo y el tomo de seguimiento me ayudó a registrar avances por alumno. En las reuniones con las familias ahora tengo datos concretos para mostrar.',
    author: 'Daniela Ferreyra',
    role: 'Docente de inglés en dos escuelas, 47 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Doy clases particulares a grupos de chicos de 8 a 11 años y me costaba mantenerlos atentos. Con el tomo de juegos didácticos y las fichas imprimibles cada clase tiene una dinámica distinta. Los padres me cuentan que sus hijos llegan contentos y repiten el vocabulario en casa.',
    author: 'Martín Peralta',
    role: 'Profesor de inglés particular, 38 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito experiencia enseñando inglés?',
    a: 'No es obligatorio. El material comienza con contenidos iniciales, aunque es recomendable contar con conocimientos básicos de inglés y enseñanza.',
  },
  {
    q: '¿Qué voy a encontrar?',
    a: 'Planificaciones, vocabulario, gramática, actividades, juegos, evaluaciones y proyectos para inglés de primaria.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Los tomos y bonos contienen consignas, ejemplos y propuestas prácticas para desarrollar en clase.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los cinco bonos están incluidos en el precio del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagás una sola vez, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El material se entrega digitalmente después de confirmar la compra.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo de apoyo y no reemplaza títulos, certificaciones ni requisitos para ejercer la docencia.',
  },
  {
    q: '¿Puedo utilizarlo a mi ritmo?',
    a: 'Sí. Podés consultar los contenidos y adaptar las propuestas a tus necesidades.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés comunicarte al correo de soporte indicado al final de esta página.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Laura Fernández', city: 'Córdoba', minutes: 2 },
  { name: 'Silvina Romero', city: 'Rosario', minutes: 4 },
  { name: 'Natalia Gómez', city: 'Buenos Aires', minutes: 7 },
  { name: 'Carolina Díaz', city: 'Mendoza', minutes: 11 },
  { name: 'Paula Medina', city: 'La Plata', minutes: 15 },
  { name: 'Gabriela Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Lucía Acosta', city: 'Salta', minutes: 24 },
  { name: 'Andrea Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Verónica Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Julieta Herrera', city: 'Santa Fe', minutes: 40 },
]
